module.exports = __webpack_public_path__ + "static/media/Chicken2.7efcb6fc.png";